import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SettingsService } from '../settings/settings.service';
import { MaterialModule } from '../material/material.module';
import { CommonModule } from '@angular/common';
import { InversionistaDataSimulacionService } from './services/inversionista-data-simulacion.service';
import { ResultadoSimulacionComponent } from './resultado-simulacion/resultado-simulacion.component';
import { MatStepper } from '@angular/material/stepper';
import { IdInversorService } from './services/id-inversor.service';
import { EventService } from './services/event.service';
import { SharedDataService } from './services/shared-data.service';
import { PdfSimulacionComponent } from './pdf-simulacion/pdf-simulacion.component';

@Component({
  selector: 'app-simulacion',
  standalone: true,
  imports: [
    MaterialModule,
    CommonModule,
    ReactiveFormsModule,
    ResultadoSimulacionComponent,
    PdfSimulacionComponent,
  ],
  templateUrl: './simulacion.component.html',
  styleUrl: './simulacion.component.less',
})
export class SimulacionComponent implements OnInit {
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('formContainer', { static: false }) formContainer!: ElementRef;
  @ViewChild('rowForm', { static: false }) rowForm!: ElementRef;


  formGroup: FormGroup;
  valForm!: FormGroup;
  enviandoBtn = false;
  showStepper: boolean = false;
  hideBtn: boolean = false;

  step: Number = 1;
  subStep: Number = 1;

  constructor(
    private _formBuilder: FormBuilder,
    private settings: SettingsService,
    public snackBar: MatSnackBar,
    private idInversorService: IdInversorService,
    private inversionistaDataSimulacionService: InversionistaDataSimulacionService,
    private eventService: EventService,
    private sharedDataService: SharedDataService
  ) {
    this.valForm = this._formBuilder.group({
      name: ['', Validators.required],
      mail: ['', [Validators.required, Validators.email]],
      rut: [
        '',
        [Validators.required, Validators.pattern('^[0-9]{7,10}[-][0-9K]$')],
      ],
      telefono: ['', [Validators.required, Validators.pattern(/^[0-9]{9}$/)]],
    });

    this.formGroup = this._formBuilder.group({
      monto: [
        '',
        [Validators.required, this.validateMonto, this.validateMontoMinimo],
      ],
      fechaEmision: ['', Validators.required],
      plazo: ['', [
        Validators.required, 
        Validators.pattern(/^[0-9]+$/),
        Validators.min(3)
      ]],
      retiro: ['', Validators.required],
      cliente: ['Externo', Validators.required],
      tasa: [''],
    });
  }

  ngOnInit(): void {
    let investorId = this.idInversorService.getIdInversor();
    this.getChartInstitucion(investorId);

    this.inversionistaDataSimulacionService.inversionistaDataSimulacion$.subscribe(
      (data) => {
        this.valForm.patchValue({
          name: data.full_name,
          mail: data.email,
          rut: data.run,
          telefono: data.telefono || '',
        });
      }
    );
  }

  validateMonto(control: AbstractControl): ValidationErrors | null {
    const value = control.value.replace(/\./g, '');
    if (value === '') {
      return null;
    }
    if (isNaN(value) || +value <= 0) {
      return { invalidMonto: true };
    }
    return null;
  }

formatRUT(event: any) {

  let value = event.target.value || '';

  value = value.replace(/\./g, '').replace(/-/g, '').toUpperCase();

  value = value.replace(/[^0-9K]/g, '');

  if (value.length > 9) {
    value = value.slice(0, 9);
  }

  if (value.length > 1) {
    value = value.slice(0, -1) + '-' + value.slice(-1);
  }

  this.valForm.controls['rut'].setValue(value, { emitEvent: false });

}

  capitalizeName() {
    const nameControl = this.formGroup.get('name');
    if (nameControl?.value) {
      let capitalized = nameControl.value
        .split(' ')
        .map((word: string) => {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(' ');
      nameControl.setValue(capitalized);
    }
  }

  convertToLowerCase(event: any): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.toLowerCase();
    this.formGroup.controls['mail'].setValue(value, { emitEvent: false });
  }

  formatMonto(input: any) {
    const originalValue = input.target.value;
    const num = originalValue.replace(/\./g, '');

    if (!isNaN(num)) {
      let formattedValue = num
        .split('')
        .reverse()
        .join('')
        .replace(/(\d{3})(?=\d)/g, '$1.');
      formattedValue = formattedValue.split('').reverse().join('');
      this.formGroup.controls['monto'].setValue(formattedValue, {
        emitEvent: false,
      });
    } else {
      this.formGroup.controls['monto'].setErrors({ invalidMonto: true });
    }
  }

  async sendForm() {
    this.enviandoBtn = true;
    try {
      const formData = {
        ...this.formGroup.value,
        ...this.valForm.value,
      };

      console.log('formData', formData);

      if (this.formGroup.valid) {
        const response: any = await this.settings.get_query(
          2,
          '/cliente-inversionista/simulation/',
          formData,
          true
        );
        console.log('Formulario enviado correctamente:', response);
        console.log('ID del inversionista2:', response._body.info.investor_id);

        const investorId = response._body.info.investor_id;
        this.idInversorService.setIdInversor(investorId);

        this.getChartInstitucion(investorId);

        this.eventService.triggerFormSubmitted();
        this.step = 2;
      } else {
        console.error('El formulario no es válido');
      }
    } catch (error: any) {
      console.error('Error al enviar el formulario:', error);
      this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
        duration: 20000,
        panelClass: 'simpli-snack',
      });
    } finally {
      this.enviandoBtn = false;
    }
  }

  async getChartInstitucion(investorId: any) {
    try {
      if (investorId) {
        const bd: any = await this.settings.get_query(
          1,
          `/cliente-inversionista/chart-institucion/${investorId}/`
        );
        const body_data: any = bd._body.info;

        console.error(body_data)

        this.sharedDataService.setChartInstitucionData(body_data);
      } else {
        console.log('ID de inversor no válido.');
      }
    } catch (error) {
      console.error('Error al obtener los datos del chart:', error);
    }
  }

  validateMontoMinimo(control: AbstractControl): ValidationErrors | null {
    const value = control.value.replace(/\./g, '');
    if (value === '') {
      return null;
    }
    if (+value < 500000) {
      return { montoMinimo: true };
    }
    return null;
  }


  siguiente_paso($ev: any, value: any, step: Number) {
    $ev.preventDefault();
  
    if (step === 1) {
      for (let c in this.valForm.controls) {
        this.valForm.controls[c].markAsTouched();
      }
      if (this.valForm.valid) {
        this.hideBtn = true;
        this.subStep = 2;
      } else {
        console.error('El sub-step 1 no es válido');
        this.snackBar.open(
          'Por favor, corrige los errores antes de continuar.',
          'Aceptar',
          {
            duration: 5000,
            panelClass: 'simpli-snack',
          }
        );
      }
    } else {
      this.enviandoBtn = true;
  
      for (let c in this.formGroup.controls) {
        this.formGroup.controls[c].markAsTouched();
      }
  
      if (this.formGroup.valid) {
        this.formContainer.nativeElement.classList.add('transition');
        this.sendForm()
        
          .finally(() => {
            this.enviandoBtn = false;
            this.formContainer.nativeElement.classList.remove('col-lg-7','col-md-7');
            this.formContainer.nativeElement.classList.add('col-lg-12','col-md-12');
          });
      } else {
        console.error('El sub-step 2 no es válido');
        this.snackBar.open(
          'Por favor, corrige los errores antes de continuar.',
          'Aceptar',
          {
            duration: 5000,
            panelClass: 'simpli-snack',
          }
        );
        this.enviandoBtn = false;
      }
    }
  }

  goToPreviousStep() {
    this.hideBtn = false;
    this.subStep = 1;
  }

  previousStep() {
    this.formContainer.nativeElement.classList.remove('col-lg-12','col-md-12');
    this.formContainer.nativeElement.classList.add('col-lg-7','col-md-7');
  }

}
